"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const translation_1 = require("../../utils/translation");
const validation_1 = require("../../utils/validation");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
const validation = (board) => {
    let validation = (0, validation_1.ap)((0, validation_1.isNotEmpty)('name')(board))((0, validation_1.isNotEmptyList)('elements')(board.elements).mapFailure(() => [
        {
            key: 'elements',
            value: (0, translation_1.getLocalization)('dashboardElements/modal/error/noElements')
        }
    ]));
    for (let i = 0; i < board.elements.length; i++) {
        const element = board.elements[i];
        switch (element.type) {
            case 'MARKDOWN':
            case 'TEXT': {
                validation = (0, validation_1.ap)((0, validation_1.isNotEmpty)('value', `element-${i}-value`)(element))(validation);
                break;
            }
            case 'LINK': {
                validation = (0, validation_1.ap)((0, validation_1.isNotEmpty)('url', `element-${i}-url`)(element))(validation);
                if (element.displayName !== null) {
                    validation = (0, validation_1.ap)((0, validation_1.isNotEmpty)('url', `element-${i}-displayName`)(element))(validation);
                }
                break;
            }
            case 'KEY-VALUE-ROW':
            case 'KEY-VALUE-COLUMN': {
                validation = (0, validation_1.ap)((0, validation_1.isNotEmpty)('value', `element-${i}-value`)(element))(validation);
                break;
            }
            default:
                break;
        }
    }
    return validation;
};
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function fetch(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/dashboard/${action.payload.parent.toLowerCase()}/${action.payload.id}`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            const validation = t
                .array(sok_types_1.Dashboard.iDashboard)
                .decode(xhr.response);
            const act = validation.fold((e) => [Actions.fetchFailed((0, errorHandling_1.parseValidationError)(e))], (res) => {
                const acts = [Actions.fetchSuccess(res)];
                return acts;
            });
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
    }
    function create(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_REQUEST), (0, operators_1.debounceTime)(100), (0, operators_1.mergeMap)((action) => validation(action.payload.dashboard).fold((x) => (0, rxjs_1.of)(Actions.createValidationFailure(x)), () => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            url: `${baseUrl}api/dashboard/${action.payload.parent.toLowerCase()}/${action.payload.id}`,
            body: action.payload.dashboard
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            const validation = sok_types_1.Dashboard.iDashboard.decode(xhr.response);
            const act = validation.fold((e) => [Actions.createFailed((0, errorHandling_1.parseValidationError)(e))], (res) => {
                const acts = [
                    Actions.createSuccess(res),
                    Actions.fetchRequest(action.payload.parent, action.payload.id)
                ];
                return acts;
            });
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.createFailed((0, errorHandling_1.parseAjaxErrorResponse)(error))))))));
    }
    function edit(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.EDIT_REQUEST), (0, operators_1.debounceTime)(100), (0, operators_1.mergeMap)((action) => validation(action.payload.dashboard).fold((x) => (0, rxjs_1.of)(Actions.editValidationFailure(x)), () => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            url: `${baseUrl}api/dashboard/${action.payload.dashboard.id}`,
            body: action.payload.dashboard
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            const validation = sok_types_1.Dashboard.iDashboard.decode(xhr.response);
            const act = validation.fold((e) => [Actions.editFailed((0, errorHandling_1.parseValidationError)(e))], (res) => {
                const acts = [
                    Actions.editSuccess(res),
                    Actions.fetchRequest(action.payload.parent, action.payload.id)
                ];
                return acts;
            });
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.editFailed((0, errorHandling_1.parseAjaxErrorResponse)(error))))))));
    }
    function remove(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.REMOVE_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'DELETE',
            url: `${baseUrl}api/dashboard/${action.payload.dashboard.id}`,
            body: action.payload.dashboard
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            const validation = sok_types_1.Dashboard.iDashboard.decode(xhr.response);
            const act = validation.fold((e) => [Actions.removeFailed((0, errorHandling_1.parseValidationError)(e))], (res) => {
                const acts = [
                    Actions.removeSuccess(res),
                    Actions.fetchRequest(action.payload.parent, action.payload.id)
                ];
                return acts;
            });
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.removeFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
    }
    return { fetch, create, edit, remove };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map